module.exports = __webpack_public_path__ + "static/media/phone_bg_medium.19cc742f.png";